import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { Text } from '@/components/common/AppText';
import { JourneyIcon, type JourneyIconName } from './journey-icons';
import { TEXT_START, useJourneyPalette } from './journey-theme';

/** Quiet note band (`.info-strip`), with neutral / warning / success tones. */
export function InfoStrip({
  text,
  tone = 'neutral',
  icon = 'info',
  style,
}: {
  text: string;
  tone?: 'neutral' | 'warning' | 'success' | 'error';
  icon?: JourneyIconName;
  /** Hosts that stack the strip in their own gap override its margins here. */
  style?: StyleProp<ViewStyle>;
}) {
  const palette = useJourneyPalette();
  const [bg, fg] =
    tone === 'warning'
      ? [palette.amberFill, palette.amber]
      : tone === 'success'
        ? [palette.greenFill, palette.green]
        : tone === 'error'
          ? [palette.redFill, palette.red]
          : [palette.group, palette.secondary];
  return (
    <View
      style={[styles.strip, { backgroundColor: bg }, style]}
      accessibilityRole={tone === 'warning' || tone === 'error' ? 'alert' : undefined}
    >
      <JourneyIcon name={icon} size={17} color={fg} />
      <Text style={[styles.text, { color: fg }, TEXT_START]}>{text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  strip: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 9,
    borderRadius: 12,
    padding: 13,
    marginTop: 20,
    marginBottom: 12,
  },
  text: { flex: 1, fontSize: 13, lineHeight: 19 },
});
